import { render, staticRenderFns } from "./pushDynamicDetail.vue?vue&type=template&id=43c17904&scoped=true"
import script from "./pushDynamicDetail.vue?vue&type=script&lang=js"
export * from "./pushDynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./pushDynamicDetail.vue?vue&type=style&index=0&id=43c17904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c17904",
  null
  
)

export default component.exports